import { Skeleton } from "@/app/components/shadcn/skeleton";

const PhotoReviewsSkeleton = () => {
  return (
    <div className="bg-white border border-gray-200 rounded-lg px-6 py-3.5">
      <div className="flex items-center justify-between mb-4">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-8 w-16" />
      </div>
      <div className="flex gap-2">
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton key={i} className="aspect-square w-full rounded-lg" />
        ))}
      </div>
    </div>
  );
};

export default PhotoReviewsSkeleton;